// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3v4iz","form":"styles_form__3e-MW"};